interface InitializersState {
    finished: number;
    total: number;
}

const DEFAULT_STATE: InitializersState = {
    finished: 0,
    total: 0,
};

const getObservableStateProxy = (stateObj: InitializersState, onFinishedCallback: () => void): InitializersState => {
    const changeHandler: ProxyHandler<InitializersState> = {
        set(target, prop, value) {
            target[prop as keyof InitializersState] = value;
            if (prop === 'finished' && target.finished === target.total && target.total > 0) {
                onFinishedCallback();
            }
            return true;
        },
    };
    return new Proxy(stateObj, changeHandler);
};

class InitializerService {
    private state: InitializersState;

    checkInitializers(onFinishedCallback: () => void) {
        this.state = getObservableStateProxy(DEFAULT_STATE, onFinishedCallback);
        const allInitializers: NodeListOf<HTMLElement> = document.querySelectorAll('[data-js-init]');

        if (allInitializers.length > 0) {
            this.state.total = allInitializers.length;
            allInitializers.forEach((initializer) => {
                this.runInitializer(initializer);
            });
        } else {
            onFinishedCallback();
        }
    }

    runInitializer(initializer: HTMLElement) {
        const initializerName = initializer.dataset.jsInit;
        switch (initializerName) {
            // case 'meta-navigation':
            //     import('../components/meta-navigation').then((module) => {
            //         module.default.init(initializer);
            //         this.state.finished++;
            //     });
            //     break;
            // case 'main-navigation':
            //     import('../components/main-navigation').then((module) => {
            //         module.default.init(initializer);
            //         this.state.finished++;
            //     });
            //     break;
            case 'footer-navigation':
                import('../components/footer-navigation').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'header-mobile':
                import('../components/header-mobile').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'collapsible-content':
                import('../components/collapsible-content').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'search':
                import('../components/search').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'skip-links':
                import('../components/skip-links').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'swiper':
                import('../components/swiper-factory').then((module) => {
                    module.default.initSwiperOnElement(initializer);
                    this.state.finished++;
                });
                break;
            case 'cart-button':
                import('../components/cart-button').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'export-excel':
                import('../components/export-excel').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'friendly-challenge':
                import('../components/friendly-challenge').then(() => {
                    this.state.finished++;
                });
                break;
            case 'is-organization':
                import('../components/is-organization').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'toast-handler':
                import('../components/toast-handler').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'form-error-handler':
                import('../components/form-error-handler').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'dynamic-filter-results':
                import('../components/dynamic-filter-results').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            default:
                console.warn(`InitializerService: No initializer found for "${initializerName}" via DOM element:`, initializer);
                this.state.finished++;
                break;
        }
    }
}

export default new InitializerService();
